import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type CommonStateType = {
  forgotPasswordEmail: string;
};

const initialState: CommonStateType = {
  forgotPasswordEmail: "",
};

const commonSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setForgotpasswordEmail: (state, action: PayloadAction<CommonStateType>) => {
      state.forgotPasswordEmail = action.payload.forgotPasswordEmail;
    },
  },
});

// Export the actions
export const { setForgotpasswordEmail } = commonSlice.actions;

// Export the reducer
export default commonSlice.reducer;
